<template>
<FormLabel :for="id">
    <input type="checkbox" :id="id" :checked="form.signup" @click="setValue('signup', !form.signup)"/> {{text}}
</FormLabel>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    id: {
      type: String,
      default: 'newsletterSubscribe',
    },
    text: {
      type: String,
      default: 'Sign me up to the newsletter',
    },
  },
  setup() {
    const { setValue, form } = usePaymentForm()

    return {
      form,
      setValue,
    }
  },
})
</script>